import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Container,
    CssBaseline,
} from '@material-ui/core';
import {
    Check,
    Clear,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Search,
    Remove,
    ViewColumn,
} from '@material-ui/icons';
import MaterialTable from 'material-table';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import DeleteIcon from '@material-ui/icons/Delete';
import Loading from '../components/Loading';
import Nav from '../components/NavBar/Nav';

import api from '../services/Api';

class Professionals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            token: '',
            drawer: false,
            loading: false,
            columns: [
                {title: 'Id', field: 'id'},
                {title: 'Nome', field: 'name'},
                {title: 'Serviços', field: 'services'},
                {title: 'Estado', field: 'state'},
                {title: 'Cidade', field: 'city'},
                {title: 'Aprovado', field: 'active'},
            ],
            data: [
                {
                    id: '1',
                    name: 'Profissional 1',
                    services: 'Mecânica, Funilaria',
                    state: 'XX',
                    city: 'Cidade 1',
                    active: 'Sim'
                },
                {
                    id: '2',
                    name: 'Profissional 2',
                    services: 'Jardinagem',
                    state: 'XX',
                    city: 'Cidade 2',
                    active: 'Não'
                },
                {
                    id: '3',
                    name: 'Profissional 3',
                    services: 'Manicure, Pedicure',
                    state: 'XX',
                    city: 'Cidade 3',
                    active: 'Sim'
                },
                {
                    id: '4',
                    name: 'Profissional 4',
                    services: 'Dog Walking',
                    state: 'XX',
                    city: 'Cidade 4',
                    active: 'Sim'
                },
            ]
        };
    }

    componentDidMount() {

        this.setState({ loading: true });

        const token = localStorage.getItem('TOKEN_KEY');

        api.post("/admin/check", { }, { headers: { Authorization: 'Bearer ' + token }})
        .then(
            res => {
                if(res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                 
                }

                if(!res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                
                }
            }
        ).catch(err => {
            console.log(err);
        })     
    }

    openDrawer = () => {
        this.setState({drawer: !this.state.drawer})
    }

    render() {
        if(this.state.loading) {
            return <Loading />;           
        }

        return (
            <div className={styles.root}>
                <CssBaseline/>
                <Nav />

                <Container maxWidth="lg" style={professionals.table}>
                    <MaterialTable
                        icons={{
                            Check: () => <Check/>,
                            Clear: () => <Clear/>,
                            Export: () => <SaveAlt/>,
                            Filter: () => <FilterList/>,
                            FirstPage: () => <FirstPage/>,
                            LastPage: () => <LastPage/>,
                            NextPage: () => <ChevronRight/>,
                            PreviousPage: () => <ChevronLeft/>,
                            Search: () => <Search/>,
                            ResetSearch: () => <Clear/>,
                            ThirdStateCheck: () => <Remove/>,
                            ViewColumn: () => <ViewColumn/>,
                            DetailPanel: () => <ChevronRight/>
                        }}
                        title="Profissionais"
                        columns={this.state.columns}
                        data={this.state.data}
                        actions={[
                            {
                              icon: () => <RemoveRedEyeIcon/>,
                              tooltip: 'Visualizar',
                              onClick: (event, rowData) => alert("Visualizar informações de " + rowData.name)
                            },
                            rowData => ({
                              icon: () => <DeleteIcon/>,
                              tooltip: 'Deletar Usuário',
                              onClick: (event, rowData) => alert("Você deletou o " + rowData.name),
                              disabled: rowData.birthYear < 2000
                            })
                          ]}
                          options={{
                            actionsColumnIndex: -1
                          }}
                    />
                </Container>

            </div>
        )
    }

}

const professionals = {

    table: {
        marginTop: 50,
    },
  
}

const styles = {
    root: {
        display: 'flex',
    },
    drawer: {
        width: 'auto',
    },
    list: {
        width: 250,
    },
}

export default withStyles(styles)(Professionals);
